module.exports = __webpack_public_path__ + "static/media/DSC09780_20180710_059-9.61473f91.jpg";